import React from 'react';
import { Link } from 'react-router-dom';
import CategoryMenu from './CategoryMenu';
import './GenderMenu.scss';
import SubMenu from './SubMenu';


// todo set dtm value parent and key
const onGenderHover = context => {
    context.stopPropagation();
    const siblingContext = context.currentTarget.parentNode.childNodes;
    for (let i = 0; i < siblingContext.length; i += 1) {
       siblingContext[i].classList.remove('active');
    }
    context.currentTarget.classList.add('active');
};
const GenderMenu = props => {
    const { genderMenuData, updateNavValueDtm, parentKey, menuData, section, dataLocale } = props;
    const { SELECT_GENDER } = dataLocale;
    return (<div className="gender-menu">
        {
            genderMenuData.url && genderMenuData.url.indexOf('lenskart.com') === -1 ?
                <Link className="nav-head" to={genderMenuData.url} onClick={() => updateNavValueDtm(menuData, parentKey)}>
                    {SELECT_GENDER}
                </Link> :
                <a className="nav-head" onClick={() => updateNavValueDtm(menuData, parentKey)} href={genderMenuData.url}>
                    {SELECT_GENDER}
                </a>
        }
        {
            genderMenuData.submenu && genderMenuData.submenu.map((genderMenu, index) => {
                return (<div key={index} className="gender-menu-section menu-line-section">
                    {
                        Object.keys(genderMenu).map((key, count) => {
                            return (
                                <div key={key} className={`gender ${count === 0 ? ' active' : ''}`} onMouseOver={ev => onGenderHover(ev)} onFocus={ev => onGenderHover(ev)}>
                                    <div className="gender_info">
                                        <span className="uppercase">{key}</span>
                                        <div className="gender_img"><img alt={key} title={key} src={genderMenu[key].img} width="48" height="48" /></div>
                                        <i className="fa fa-angle-right"></i>
                                    </div>

                                    {genderMenu[key].category && <div className={`display-none gender_category gender-${key}`}>
                                        <CategoryMenu dataLocale={dataLocale} categoryMenuData={genderMenu[key].category} updateNavValueDtm={updateNavValueDtm} parentKey={parentKey} section={section} subSection={key} />
                                    </div>}
                                    {!genderMenu[key].category && genderMenu[key].submenu && <div className={`display-none gender_category submenu gender-${key}`}>
                                        <SubMenu submenu={genderMenu[key].submenu} updateNavValueDtm={updateNavValueDtm} parentKey={parentKey} section={section} subSection={key} />
                                    </div>}
                                </div>);
                        })
                    }
                </div>);
            })
        }
    </div>);
};

export default GenderMenu;
